module.exports = __webpack_public_path__ + "static/media/hero-banner-xs.70bc1ae6.jpg";